



















































































































import { Watch, Component, Prop, Vue } from 'vue-property-decorator'
import { Pipeline } from '@/api/model/pipeline'
import { PipelineAPI, PipelinePhaseAPI } from '@/api/backend-client'
import { v4 as uuid} from 'uuid'
import InputSwitch from '@/components/input/InputSwitch.vue'
import InputMoney from '@/components/input/InputMoney.vue'
import InputCheckbox from '@/components/input/InputCheckbox.vue'
import InputRadio from '@/components/input/InputRadio.vue'
import { Branch } from '@/api/model/branch'
import { PipelineLinkedBranch } from '@/api/model/pipeline-linked-branch'

@Component({
    components: {
        InputSwitch,
        InputMoney,
        InputCheckbox,
        InputRadio,
    },
})
export default class EditPipelineTeamsModal extends Vue {
    @Prop({ required: true }) readonly pipeline!: Pipeline
    @Prop({ type: Boolean, default: false }) readonly value!: boolean
    @Prop({ type: Boolean, default: false }) readonly showPhaseWarning!: boolean

    fallbackBranchId = null

    visible: boolean = false
    loading: boolean = false

    selectedPipeline: Pipeline = null

    @Watch('pipeline', { immediate: true })
    onPipelineChanged(): void {
        this.selectedPipeline = this.pipeline.clone()
        this.fallbackBranchId = this.selectedPipeline?.fallbackBranch?.id
    }

    @Watch('value')
    onValueChanged(): void {
        this.visible = this.value
    }

    @Watch('visible')
    onVisibleChanged(): void {
        this.$emit('input', this.visible)
    }

    get availableBranches() {
        return this.$currentCompany.getAvailableBranches()
    }

    get activePipelineBranchIds() {
        return this.availableBranches.filter(branch => {
            return !!this.pipelineLinkedBranches.find(linkedBranch => linkedBranch.branch.id === branch.id)
        }).map(branch => branch.id)
    }

    get activeFallbackBranch() {
        return this.availableBranches.find(branch => {
            return branch.id === this.fallbackBranchId
        })
    }

    get pipelineLinkedBranches() {
        return this.selectedPipeline.linkedBranches
    }

    toggleBranchFromPipeline(branch: Branch) {
        const index = this.pipelineLinkedBranches.findIndex(
            selectedPipelineBranch => selectedPipelineBranch.branch.id === branch.id,
        )

        if (index !== -1) {
            this.pipelineLinkedBranches.splice(
                index,
                1,
            )

            if (this.fallbackBranchId === branch.id) {
                this.fallbackBranchId = null
            }
        } else {
            this.pipelineLinkedBranches.push(new PipelineLinkedBranch(
                this.selectedPipeline,
                branch,
                0,
                0,
            ))
        }
    }

    get isFallbackBranchValid() {
        if (this.pipelineLinkedBranches.length === 0) {
            return true
        }

        const index = this.pipelineLinkedBranches.findIndex(
            selectedPipelineBranch => selectedPipelineBranch.branch.id === this.fallbackBranchId,
        )

        return index !== -1
    }

    async save() {
        this.loading = true

        this.selectedPipeline.branches = []
        this.pipelineLinkedBranches.forEach(linkedBranch => {
            this.selectedPipeline.branches.push(linkedBranch.branch)
        })

        this.selectedPipeline.fallbackBranch = this.activeFallbackBranch

        await PipelineAPI.update(this.selectedPipeline.id, this.selectedPipeline)

        this.$emit('update:pipeline', this.selectedPipeline)

        this.visible = false
        this.loading = false
    }

    showModal(): void {
        this.visible = true
    }

    hideModal(): void {
        this.visible = false
    }
}
